import { cilArrowLeft } from '@coreui/icons'
import CIcon from '@coreui/icons-react'
import {
  CButton,
  CCard,
  CCardBody,
  CCol,
  CContainer,
  CForm,
  CFormInput,
  CFormSelect,
  CRow,
} from '@coreui/react'
import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { signupAppUser } from 'src/redux/registration'
import { useEffect } from 'react'
import { getCountry } from 'src/redux/country'
import { getStates } from 'src/redux/states'
import { getCities } from 'src/redux/cities'

const Addusers = () => {
  const [loading, setLoading] = useState(false)
  const dispatch = useDispatch()
  const { isOtpSend } = useSelector((state) => state.signupapp)

  const goBack = () => {
    window.history.back()
  }

  const [countryCode, setCountryCode] = useState('')
  const [stateCode, setStateCode] = useState('')

  const { countryData } = useSelector((state) => state.country)
  const { statesData } = useSelector((state) => state.states)
  const { citiesData } = useSelector((state) => state.cities)

  useEffect(() => {
    dispatch(getCountry())
  }, [dispatch])

  useEffect(() => {
    dispatch(getStates(countryCode))
  }, [dispatch, countryCode])

  useEffect(() => {
    dispatch(getCities(`${countryCode}/${stateCode}`))
  }, [dispatch, stateCode])

  const [SignupformData, setSignupFormData] = useState({
    name: '',
    email_id: '',
    mobile_no: '',
    password: '',
    whatsapp_no: '',
    country: '',
    state: '',
    city: '',
    address: '',
    residence1_type: '',
    residence1_area: '',
    residence2_type: '',
    residence2_area: '',
    is_active: true,
  })

  const [validated1, setValidated1] = useState(false)
  const handleSignup = async (event) => {
    event.preventDefault()
    const form = event.currentTarget
    if (form.checkValidity() === false) {
      event.stopPropagation()
      setValidated1(true)
      return
    }

    setValidated1(true)
    setLoading(true)
    try {
      await dispatch(signupAppUser(SignupformData))
      setSignupFormData({
        name: '',
        email_id: '',
        mobile_no: '',
        password: '',
        whatsapp_no: '',
        country: '',
        state: '',
        city: '',
        address: '',
        residence1_type: '',
        residence1_area: '',
        residence2_type: '',
        residence2_area: '',
        is_active: true,
      })
      setCountryCode('')
      setStateCode('')
      setValidated1(false)
    } catch (error) {
      console.log(error)
    } finally {
      setLoading(false)
    }
  }

  return (
    <CContainer>
      <CRow className="justify-content-center mb-4">
        <CCol xl={10}>
          <CCard className="px-4 shadow-lg">
            <CCardBody className="p-4">
              <CForm
                className="row g-3 needs-validation"
                noValidate
                validated={validated1}
                onSubmit={handleSignup}
              >
                <CCol xs={12} className="d-flex justify-content-between align-items-center mb-3">
                  <h2 className="mb-0">Registration</h2>
                  <CButton color="secondary" size="sm" onClick={goBack}>
                    <CIcon icon={cilArrowLeft} className="me-1" /> Go Back
                  </CButton>
                </CCol>

                <CCol md={4}>
                  <CFormInput
                    id="name"
                    label="Full Name"
                    placeholder="Enter name"
                    feedbackInvalid="Please provide a valid name"
                    value={SignupformData.name}
                    onChange={(e) => setSignupFormData({ ...SignupformData, name: e.target.value })}
                    required
                  />
                </CCol>
                <CCol md={4}>
                  <CFormInput
                    id="email_id"
                    type="email"
                    label="Email Address"
                    placeholder="Enter email address"
                    feedbackInvalid="Please provide a valid email"
                    value={SignupformData.email_id}
                    onChange={(e) =>
                      setSignupFormData({ ...SignupformData, email_id: e.target.value })
                    }
                    required
                  />
                </CCol>
                <CCol md={4}>
                  <CFormInput
                    id="mobile_no"
                    type="number"
                    label="Mobile Number"
                    placeholder="Enter mobile number"
                    feedbackInvalid="Please provide a valid number"
                    value={SignupformData.mobile_no}
                    onChange={(e) =>
                      setSignupFormData({ ...SignupformData, mobile_no: e.target.value })
                    }
                    required
                  />
                </CCol>

                <CCol md={4}>
                  <CFormInput
                    id="password"
                    type="password"
                    label="Password"
                    placeholder="Enter password"
                    feedbackInvalid="Please provide a password"
                    value={SignupformData.password}
                    onChange={(e) =>
                      setSignupFormData({ ...SignupformData, password: e.target.value })
                    }
                    required
                  />
                </CCol>
                <CCol md={4}>
                  <CFormInput
                    id="whatsapp_no"
                    type="text"
                    label="WhatsApp Number"
                    placeholder="Enter WhatsApp number"
                    feedbackInvalid="Please provide WhatsApp number"
                    value={SignupformData.whatsapp_no}
                    onChange={(e) =>
                      setSignupFormData({ ...SignupformData, whatsapp_no: e.target.value })
                    }
                    required
                  />
                </CCol>
                <CCol md={8}>
                  <CFormInput
                    id="address"
                    type="text"
                    label="Address"
                    placeholder="Enter full address"
                    feedbackInvalid="Please provide an address"
                    value={SignupformData.address}
                    onChange={(e) =>
                      setSignupFormData({ ...SignupformData, address: e.target.value })
                    }
                    required
                  />
                </CCol>

                <CCol md={4}>
                  <CFormSelect
                    id="is_active"
                    label="Is Active"
                    feedbackInvalid="Please select status"
                    value={SignupformData.is_active ? 'true' : 'false'}
                    onChange={(e) =>
                      setSignupFormData({ ...SignupformData, is_active: e.target.value === 'true' })
                    }
                    required
                  >
                    <option value="true">Active</option>
                    <option value="false">Inactive</option>
                  </CFormSelect>
                </CCol>

                <CCol md={4}>
                  <CFormSelect
                    id="country"
                    label="Country"
                    feedbackInvalid="Please select a country"
                    value={SignupformData.country}
                    onChange={(e) => {
                      countryData?.map(
                        ({ name, isoCode }) => name === e.target.value && setCountryCode(isoCode),
                      )
                      setSignupFormData({
                        ...SignupformData,
                        country: e.target.value,
                        state: '',
                        city: '',
                      })
                    }}
                    required
                  >
                    <option value="">Select country</option>
                    {countryData?.map(({ name }, index) => (
                      <option key={index} value={name}>
                        {name}
                      </option>
                    ))}
                  </CFormSelect>
                </CCol>
                <CCol md={4}>
                  <CFormSelect
                    id="state"
                    label="State"
                    feedbackInvalid="Please select a state"
                    value={SignupformData.state}
                    onChange={(e) => {
                      statesData?.map(
                        ({ name, isoCode }) => name === e.target.value && setStateCode(isoCode),
                      )
                      setSignupFormData({
                        ...SignupformData,
                        state: e.target.value,
                        city: '',
                      })
                    }}
                    required
                  >
                    <option value="">Select state</option>
                    {statesData?.map(({ name }, index) => (
                      <option key={index} value={name}>
                        {name}
                      </option>
                    ))}
                  </CFormSelect>
                </CCol>
                <CCol md={4}>
                  <CFormSelect
                    id="city"
                    label="City"
                    feedbackInvalid="Please select a city"
                    value={SignupformData.city}
                    onChange={(e) => setSignupFormData({ ...SignupformData, city: e.target.value })}
                    required
                  >
                    <option value="">Select city</option>
                    {citiesData?.map(({ name }, index) => (
                      <option key={index} value={name}>
                        {name}
                      </option>
                    ))}
                  </CFormSelect>
                </CCol>

                <CCol md={4}>
                  <CFormSelect
                    id="residence1_type"
                    label="Residence Type (Current)"
                    feedbackInvalid="Please select current residence type"
                    value={SignupformData.residence1_type}
                    onChange={(e) =>
                      setSignupFormData({ ...SignupformData, residence1_type: e.target.value })
                    }
                  >
                    <option value="">Select type</option>
                    <option value="own">Own</option>
                    <option value="rent">Rent</option>
                    <option value="relative">Relative</option>
                  </CFormSelect>
                </CCol>
                <CCol md={8}>
                  <CFormInput
                    id="residence1_area"
                    type="text"
                    label="Residence Area"
                    placeholder="Enter residence area"
                    feedbackInvalid="Required"
                    value={SignupformData.residence1_area}
                    onChange={(e) =>
                      setSignupFormData({ ...SignupformData, residence1_area: e.target.value })
                    }
                  />
                </CCol>
                <CCol md={4}>
                  <CFormSelect
                    id="residence2_type"
                    label="Residence Type (Hometown)"
                    feedbackInvalid="Please select hometown residence type"
                    value={SignupformData.residence2_type}
                    onChange={(e) =>
                      setSignupFormData({ ...SignupformData, residence2_type: e.target.value })
                    }
                  >
                    <option value="">Select type</option>
                    <option value="own">Own</option>
                    <option value="rent">Rent</option>
                    <option value="relative">Relative</option>
                  </CFormSelect>
                </CCol>
                <CCol md={8}>
                  <CFormInput
                    id="residence2_area"
                    type="text"
                    label="Hometown Area"
                    placeholder="Enter hometown area"
                    feedbackInvalid="Required"
                    value={SignupformData.residence2_area}
                    onChange={(e) =>
                      setSignupFormData({ ...SignupformData, residence2_area: e.target.value })
                    }
                  />
                </CCol>

                <CCol xs={12} className="text-end">
                  <CButton type="submit" color="success" className="text-white">
                    Register
                  </CButton>
                </CCol>
              </CForm>
            </CCardBody>
          </CCard>
        </CCol>
      </CRow>
    </CContainer>
  )
}

export default Addusers
